export const CONVERSATION_TITLE_LENGTH = {
  MIN: 25,
  MAX: 200,
};

export const CONVERSATION_MESSAGES = {
  TITLE_REQUIRED: "Conversation title cannot be empty.",
  TITLE_LENGTH: `Character limit should be between ${CONVERSATION_TITLE_LENGTH.MIN} to ${CONVERSATION_TITLE_LENGTH.MAX}.`,
  RENAME_SUCCESS: "Conversation renamed successfully.",
  DELETE_BLOCKED_WHILE_LOADING: "Deletion is not allowed while the current conversation is loading.",
  CONVERSATION_LOADING: "Conversation loading, try again shortly.",
};
